module.exports = __webpack_public_path__ + "static/img/car_8_6_box@3x.f2e6ea39.png";